export default __webpack_public_path__ + "static/media/icon-doordash.80a9a208.svg";